var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rangk-wrap"},_vm._l((_vm.list),function(item){return _c('div',{staticClass:"item item-progress-wrap"},[_c('div',{staticClass:"label-wrap"},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.name))]),_c('span',{staticClass:"kc"},[_vm._v(_vm._s(item.count)+_vm._s(item.dw||''))])]),_c('CcProgress',{attrs:{"style-wrap":{
        height: '6.6px',
        width: '100%',
        'background-color': 'rgba(0,0,0,0.1)'
      },"color":'linear-gradient(90deg, #412DD0 0%, #2BD6F9 100%)',"num":+item.rate,"show-progress-count":false}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }